import { render } from "./ExampleTile.vue?vue&type=template&id=1cc16dc4&ts=true"
import script from "./ExampleTile.vue?vue&type=script&lang=ts"
export * from "./ExampleTile.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__